import { GetPartnerWorkerResponse } from 'partner/shared/services/partner-worker-service.types';
import { ModalPanelBody } from 'redesign';
import { useGetPartnerWorkerDetailTabs } from '../hooks/use-get-partner-worker-detail-tabs';

export const PartnerWorkerDetailBody = ({ data }: { data: GetPartnerWorkerResponse }) => {
  const tabs = useGetPartnerWorkerDetailTabs(data);
  return <ModalPanelBody tabs={tabs} />;
};
